import { Emitter } from "@core/events/emitter";
import type { IToastsModel, Toast } from "./IToastsModel";

/**
 * `InMemoryToastsModel` — local-only implementation of {@link IToastsModel}.
 * Auto-dismisses entries whose `autoDismissMs` is set. The real production
 * toaster (M6) replaces this with one that also surfaces cloud / multiuser
 * status, but the interface stays the same.
 */
export class InMemoryToastsModel implements IToastsModel {
  readonly onChanged = new Emitter<ReadonlyArray<Toast>>();
  private m_toasts: Toast[] = [];

  get toasts(): ReadonlyArray<Toast> {
    return this.m_toasts;
  }

  push(input: Omit<Toast, "id" | "createdAt">): Toast {
    const toast: Toast = {
      ...input,
      id: `toast.${Date.now()}.${Math.random().toString(36).slice(2, 6)}`,
      createdAt: Date.now(),
    };
    this.m_toasts = [...this.m_toasts, toast];
    this.onChanged.emit(this.m_toasts);
    if (toast.autoDismissMs !== undefined && toast.autoDismissMs > 0) {
      setTimeout(() => this.dismiss(toast.id), toast.autoDismissMs);
    }
    return toast;
  }

  dismiss(id: string): void {
    const next = this.m_toasts.filter((t) => t.id !== id);
    if (next.length === this.m_toasts.length) return;
    this.m_toasts = next;
    this.onChanged.emit(this.m_toasts);
  }
}
